import { Subject } from 'rxjs';

export class ProgressService {
    progressEventObservable: Subject<any> = new Subject();
}
